import React, { useEffect, useState } from "react";
import "./payment.css";
import confetti from "canvas-confetti";
import { useSearchParams } from "react-router-dom";

export const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const txnId = searchParams.get("txnId");
  const [payment, setPayment] = useState({});

  useEffect(() => {
    if (payment.status === "success") {
      const duration = 1 * 1000;
      const end = Date.now() + duration;

      (function frame() {
        confetti({
          particleCount: 5,
          angle: 60,
          spread: 55,
          origin: { x: 0 },
        });
        confetti({
          particleCount: 5,
          angle: 120,
          spread: 55,
          origin: { x: 1 },
        });

        if (Date.now() < end) {
          requestAnimationFrame(frame);
        }
      })();
    }
  }, []);

  useEffect(() => {
    if (txnId) {
      fetch(
        `${process.env.REACT_APP_API_URL}/nrcb/ecom/payment/verify/${txnId}`
      )
        .then((res) => {
          return res.json();
        })
        .then((data) => {
          setPayment(data);
        })
        .catch((err) => {
          console.error("Payment fetch error:", err);
          setPayment({ status: "error", message: "Failed to verify payment" });
        });
    }
  }, [txnId]);

  if (payment.status === "success") {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
        <div
          className="card shadow-lg border-0 rounded-4 p-4 text-center position-relative"
          style={{ maxWidth: "450px", zIndex: 10 }}
        >
          <div className="checkmark-container mb-3">
            <svg
              className="checkmark"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 52 52"
            >
              <circle
                className="checkmark-circle"
                cx="26"
                cy="26"
                r="25"
                fill="none"
              />
              <path
                className="checkmark-check"
                fill="none"
                d="M14 27l7 7 16-16"
              />
            </svg>
          </div>

          <h3 className="fw-bold">Payment Successful</h3>
          <p className="text-muted">Thank you for your purchase!</p>

          <div className="border rounded-3 p-3 text-start my-3 bg-white">
            <p className="mb-2">
              <strong>Amount Paid:</strong> {payment?.amount}
            </p>
            <p className="mb-2">
              <strong>Date &amp; Time:</strong> {payment?.dateTime}
            </p>
            <p className="mb-0">
              <strong>Reference Number:</strong> {payment?.txnId}
            </p>
          </div>

          <a href="/" className="btn btn-success rounded-3 px-4 py-2">
            Return to Homepage
          </a>
        </div>
      </div>
    );
  }
};

export const PaymentFailure = () => {
  const [searchParams] = useSearchParams();
  const txnId = searchParams.get("txnId");
  const [payment, setPayment] = useState({});

  useEffect(() => {
    if (txnId) {
      fetch(
        `${process.env.REACT_APP_API_URL}/nrcb/ecom/payment/verify/${txnId}`
      )
        .then((res) => {
          return res.json();
        })
        .then((data) => {
          setPayment(data);
        })
        .catch((err) => {
          console.error("Payment fetch error:", err);
          setPayment({ status: "error", message: "Failed to verify payment" });
        });
    }
  }, [txnId]);

  if (payment.status === "failed") {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
        <div
          className="card shadow-lg border-0 rounded-4 p-4 text-center position-relative"
          style={{ maxWidth: "450px", zIndex: 10 }}
        >
          <div className="checkmark-container mb-3 d-flex justify-content-center">
            <svg
              className="crossmark"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 52 52"
            >
              <circle
                className="crossmark-circle"
                cx="26"
                cy="26"
                r="25"
                fill="none"
              />
              <path
                className="crossmark-cross"
                fill="none"
                d="M16 16 36 36 M36 16 16 36"
              />
            </svg>
          </div>

          <h3 className="fw-bold text-danger">Payment Failed</h3>
          <p className="text-muted">
            {" "}
            Please return to purchase your order in cart.
          </p>

          <div className="d-flex justify-content-center gap-3 mt-3">
            <a href="/" className="btn btn-success rounded-3 px-4 py-2">
              Return to Homepage
            </a>
          </div>
        </div>
      </div>
    );
  }
};
